import { render, staticRenderFns } from "./AppointmentsItemView.vue?vue&type=template&id=efe6d636&scoped=true&"
import script from "./AppointmentsItemView.vue?vue&type=script&lang=ts&"
export * from "./AppointmentsItemView.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentsItemView.vue?vue&type=style&index=0&id=efe6d636&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe6d636",
  null
  
)

export default component.exports